// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/es7.map.of.js
// module id = PP+U
// module chunks = 0